<template>
  <span style="display:none" aria-hidden="true"></span>
</template>

<script setup>
import { onMounted, onBeforeUnmount, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { hasKioskBridge, KIOSK_IDLE_TIMEOUT_MS } from '@/config/kiosk'
import { kioskSession, paymentBusy } from '@/config/kioskSession'

// Inattività massima su qualsiasi pagina che non sia la home: poi torna alla home.
const IDLE_MS = KIOSK_IDLE_TIMEOUT_MS
const TICK_MS = 250

const route = useRoute()
const router = useRouter()

let timer = null
let ticker = null
let deadlineAt = 0
let unsubProgress = null

// Pagine senza timeout: la home (pagina di partenza), il pannello di
// manutenzione (durante un carico il contante entra fisicamente senza toccare
// lo schermo: un ritorno automatico lascerebbe la sessione di refill aperta) e
// l'attesa della registrazione da telefono (il socio compila sul proprio
// dispositivo per parecchi minuti senza toccare il totem: 2 minuti di inattività
// butterebbero via il carrello a metà procedura).
//
// L'esenzione è sicura solo perché /kiosk-wait ha un timer proprio, dimensionato
// sulla scadenza della sessione: senza, il totem resterebbe bloccato lì per
// sempre se il socio se ne andasse.
const isExempt = () => route.path === '/kiosk' || route.path === '/'
  || route.path.startsWith('/kiosk-admin') || route.path.startsWith('/kiosk-wait')

function goHome () {
  // Con il Cashmatic che sta incassando il timeout non annulla niente: il
  // pagamento ha il suo timer e il suo «Annulla», e il contante già inserito
  // non va perso. Si riarma e si ricontrolla.
  if (paymentBusy()) { reset(); return }
  if (!isExempt()) router.push({ path: '/kiosk' })
}

function updateSecondsLeft () {
  kioskSession.idleSecondsLeft = Math.max(0, Math.ceil((deadlineAt - Date.now()) / 1000))
}

function reset () {
  if (timer) { clearTimeout(timer); timer = null }
  if (ticker) { clearInterval(ticker); ticker = null }
  kioskSession.idleSecondsLeft = null
  if (isExempt()) return
  deadlineAt = Date.now() + IDLE_MS
  timer = setTimeout(goHome, IDLE_MS)
  // Il valore si legge dalla scadenza, non si decrementa: non deriva col ritmo del timer.
  ticker = setInterval(updateSecondsLeft, TICK_MS)
  updateSecondsLeft()
}

// Attività che riazzera il timer. L'inserimento di contante (eventi di
// progresso del Cashmatic) conta come attività, così il timeout non scatta
// mentre il socio sta pagando anche se non tocca lo schermo.
const ACTIVITY = ['pointerdown', 'keydown', 'touchstart', 'wheel']

onMounted(() => {
  ACTIVITY.forEach((e) => window.addEventListener(e, reset, { passive: true }))
  if (hasKioskBridge()) unsubProgress = window.kioskPay.onProgress(reset)
  reset()
})

onBeforeUnmount(() => {
  ACTIVITY.forEach((e) => window.removeEventListener(e, reset))
  if (unsubProgress) unsubProgress()
  if (timer) clearTimeout(timer)
  if (ticker) clearInterval(ticker)
  kioskSession.idleSecondsLeft = null
})

// A ogni cambio pagina riparte il conteggio (e si disattiva sulla home).
watch(() => route.path, reset)
</script>
